module.exports = __webpack_public_path__ + "img/share_title-bg_red.996744ab.png";